"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPasskey = exports.registerPasskey = void 0;
var registerPasskey_1 = require("./registerPasskey");
Object.defineProperty(exports, "registerPasskey", { enumerable: true, get: function () { return registerPasskey_1.registerPasskey; } });
var getPasskey_1 = require("./getPasskey");
Object.defineProperty(exports, "getPasskey", { enumerable: true, get: function () { return getPasskey_1.getPasskey; } });
